import {clearCards} from './list';
import {flyToCoords} from '../methods/fly';
import {apmonth, intcomma} from 'journalize';
import moment from 'moment';

export const writeRobotext = fireList => {
  // Write robotext for most recent fire
  const summary = document.getElementById('summary');
  let ca_fires = fireList.filter(f => f.sublist == 'ca');
  if(ca_fires.length === 0){
    summary.innerHTML = `<p>There are no active fires in California right now.</p>`;
    document.querySelector('#ca-fires .head').style.display = 'none';
  } else {
    // Get the most recent fire
    fireList.forEach(d => d['start_datetime'] = new Date(d['start_date']));
    ca_fires.sort((a, b) => (a.start_datetime < b.start_datetime) ? 1 : -1);
    const latestFire = ca_fires[0];

    // Calculate the time difference of two dates
    const diff = new Date().getTime() - new Date(latestFire.start_datetime);
    let days = Math.floor(diff / (1000 * 3600 * 24));
    // this is a temp fix needs to be revisited
    if(new Date().getHours() >= 17){
      days -= 1;
    }
    let startedOn = `on ${apmonth(latestFire.start_datetime)} ${latestFire.start_datetime.getUTCDate()}`;
    if(Math.round(days) === 0){
        startedOn = 'today';
    }
    if(latestFire.slug === 'slink'){
      startedOn = `on Sept. 1`;
    }
    // Write robotext for most recent fire
    if(latestFire.containment && latestFire.acres > 0){
      summary.innerHTML = `<p>The most recent fire is the <span class='latest-fire'>${latestFire.name}</span> fire, which started ${startedOn}. It is ${latestFire.containment}% contained and has burned ${intcomma(latestFire.acres)} acres so far.</p>`;
    } else {
      summary.innerHTML = `<p>The most recent fire is the <span class='latest-fire'>${latestFire.name}</span> fire, which started ${startedOn}.</p>`;
    }

      // Largest fire robotext
      ca_fires.sort((a, b) => (a.acres < b.acres) ? 1 : -1);
      const largestFire = ca_fires[0];
      // summary.innerHTML += `<p>The largest active fire is the <span class="largest-fire">${largestFire.name}</span> fire, which has burned ${intcomma(largestFire.acres)} acres so far. It started on ${apmonth(largestFire.start_datetime)} ${largestFire.start_datetime.getUTCDate()} and is ${largestFire.containment}% contained.</p>`

      // Click for the most recent fire
      const latestLink = document.getElementsByClassName('latest-fire')[0];
      latestLink.addEventListener('click', (e) => {
        // Clear any existing active cards
        clearCards();

        // Make this card active
        const el = document.getElementById(`card-${latestFire.slug}`);
        el.classList.add("active");
        // Fly to the fire
        flyToCoords(
            latestFire.x,
            latestFire.y
        );
        // Scroll to the item in the list
        el.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
      })

      // Largest fire click event
      // const largestLink = document.getElementsByClassName('largest-fire')[0];
      // largestLink.addEventListener('click', (e) => {
      //   // Clear any existing active cards
      //   clearCards();
      //   // Make this card active
      //   const el = document.getElementById(`card-${largestFire.slug}`);
      //   el.classList.add("active");
      //   // Fly to the fire
      //   flyToCoords(
      //       largestFire.x,
      //       largestFire.y
      //   );
      //   // Scroll to the item in the list
      //   el.scrollIntoView({
      //     block: "start",
      //     behavior: "smooth"
      //   });
      // });
  }
}
